/** @jsx jsx */

import React, { Fragment as _, useMemo, createContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import getTempTextImageData from 'services/getTempTextImageContinueBtnData';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Image from 'components/lib/Image';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext } from './interactionContext';
import Sortation from './Sortation';
import SortationHeading from './SortationHeading';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from '@chameleoncreator/creator-app';
import IELayout from 'components/Layouts/IELayout';
import EditableButton from 'components/lib/EditableBtn';
import Media from 'components/lib/Media';
import Video from 'components/lib/Video';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

// - Sortation
//         - SortationContainer
//           - Text
//           - SortationAnswers
//             - SortationAnswer (repeat)
//               - Text
//           - Text
//         - Button
//         - Feedback (correct)
//           - Image
//           - Text
//           - Button
//         - Feedback (incorrect)
//           - Image
//           - Text
//           - Button

const Components = {
  Row,
  Column,
  Text: EditableText,
  Image,
  Video,
  Transcript,
  SVG,
  Embed,
  Media,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: () => null,
  // EditableButton,
  // Sortation: ({ children, ...props }) => children,
  // SortationContainer: ({ children }) => children,
  // SortationAnswers: ({ children }) => children,
  // SortationAnswer: ({ children }) => children,
  Sortation: ({ children, ...props }) => (
    <div
      css={css`
        width: 100%;
      `}
    >
      <Sortation {...{ children, ...props }} />
    </div>
  ),
  SortationHeading0: SortationHeading,
  SortationHeading1: SortationHeading,
  Answer: () => null,
  Feedback: ({ children }) => children,
  // Feedback: () => null,
  Correct: () => null,
  Incorrect: () => null,
  Attempt: () => null,

  Modal: () => null,
  ...IELayout(interactionContext),
};

const SortationDisplay = props => {
  const interactionBlock = getBlockById(props.blockId);

  const container = (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );

  return window.dev()
    ? container
    : useMemo(() => {
        // console.log('sortation renders');
        return container;
      }, [props.isOpen, interactionBlock.props.lockDown]);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
};

export default SortationDisplay;
